import React from 'react';
import { getTemplatesForSku, getSkuCategoryName, getSkuCategory } from '../utils/templateMapping';

const TemplateSelectShinola = ({
  sku,
  selectedTemplate,
  onTemplateChange,
  isNoPrice
}) => {
  const templates = getTemplatesForSku(sku, isNoPrice);
  const category = getSkuCategory(sku);
  const categoryName = getSkuCategoryName(category);

  if (!templates || templates.length === 0) {
    return (
      <div className="template-select-container">
        <p style={{ color: '#e74c3c', fontStyle: 'italic' }}>
          No templates available for this SKU pattern.
        </p>
      </div>
    );
  }

  return (
    <div className="template-select-container">
      <style jsx>{`
        .template-select-container {
          margin: 15px 0;
        }

        .category-info {
          background: linear-gradient(135deg, #3498db, #2980b9);
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          margin-bottom: 15px;
          font-weight: 600;
          text-align: center;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .template-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 12px;
          max-height: 300px;
          overflow-y: auto;
          border: 1px solid #e1e5e9;
          border-radius: 8px;
          padding: 15px;
          background: #f8fafc;
        }

        .template-option {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 15px;
          background: white;
          border: 2px solid #dee2e6;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          user-select: none;
        }

        .template-option:hover {
          border-color: #3498db;
          background-color: #e3f2fd;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .template-option input[type="radio"] {
          width: 18px;
          height: 18px;
          margin: 0;
          cursor: pointer;
          accent-color: #3498db;
          pointer-events: none;
        }

        .template-option:has(input[type="radio"]:checked) {
          background: linear-gradient(135deg, #3498db, #2980b9);
          color: white;
          border-color: #3498db;
          box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
        }

        .template-details {
          flex: 1;
          min-width: 0;
          pointer-events: none;
        }

        .template-name {
          font-weight: 600;
          font-size: 1rem;
          margin-bottom: 6px;
          line-height: 1.3;
        }

        .template-path {
          font-size: 0.85rem;
          opacity: 0.8;
          font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
          word-break: break-all;
          line-height: 1.3;
        }

        .template-option:has(input[type="radio"]:checked) .template-path {
          opacity: 0.9;
        }

        .template-option:focus {
          outline: 2px solid #3498db;
          outline-offset: 2px;
        }

        .selection-summary {
          background: #e8f5e8;
          border: 1px solid #c3e6cb;
          border-radius: 8px;
          padding: 15px;
          margin-top: 15px;
          font-size: 0.95rem;
        }

        .selection-summary strong {
          color: #155724;
        }

        @media (max-width: 768px) {
          .template-option {
            padding: 12px;
            gap: 10px;
          }

          .template-name {
            font-size: 0.95rem;
          }

          .template-path {
            font-size: 0.8rem;
          }

          .template-grid {
            max-height: 250px;
            padding: 12px;
          }
        }
      `}</style>

      <div className="category-info">
        📋 {categoryName} Templates ({templates.filter(template => !template.manufacturing).length} available)
      </div>

      <div className="template-grid">
        {templates.map((template, index) => {
          if (template.manufacturing) {
            return null;
          }
          return (
            <div
              key={index}
              className="template-option"
              onClick={() => onTemplateChange(template.path)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onTemplateChange(template.path);
                }
              }}
              tabIndex={0}
              role="radio"
              aria-checked={selectedTemplate === template.path}
            >
              <input
                type="radio"
                id={`template-${index}`}
                name="shinola-template"
                value={template.path}
                checked={selectedTemplate === template.path}
                onChange={(e) => onTemplateChange(e.target.value)}
                tabIndex={-1}
              />
              <div className="template-details">
                <div className="template-name">
                  {template.name}
                </div>
                <div className="template-path">
                  {template.path}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {selectedTemplate && (
        <div className="selection-summary">
          <strong>Selected Template:</strong> {templates.find(t => t.path === selectedTemplate)?.name || 'Unknown'}
        </div>
      )}
    </div>
  );
};

export default TemplateSelectShinola;
